// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Theme__Color = require("../../../reason/common/Theme/Theme__Color.bs.js");
var SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var MarkPropertyAsSoldDialog = require("../ClientPage/MarkPropertyAsSoldDialog.bs.js");
var MyClientsWidgetRowLayout = require("./MyClientsWidgetRowLayout.bs.js");
var MyClientsWidgetComponents = require("./MyClientsWidgetComponents.bs.js");
var MyClientsWidgetDeleteDialog = require("./MyClientsWidgetDeleteDialog.bs.js");
var RenewForSalePropertyMutation = require("../ClientPage/RenewForSalePropertyMutation.bs.js");
var OwnForSalePropertyStatusLabel = require("../OwnForSalePropertyStatusLabel.bs.js");
var WithdrawForSalePropertyDialog = require("../ClientPage/WithdrawForSalePropertyDialog.bs.js");
var MarkPropertyAsUnderContractDialog = require("../ClientPage/MarkPropertyAsUnderContractDialog.bs.js");
var MyClientsWidgetSeller_seller_graphql = require("../../../__generated__/MyClientsWidgetSeller_seller_graphql.bs.js");
var MyClientsWidgetSeller_Menu_seller_graphql = require("../../../__generated__/MyClientsWidgetSeller_Menu_seller_graphql.bs.js");
var MyClientsWidgetSeller_name_seller_graphql = require("../../../__generated__/MyClientsWidgetSeller_name_seller_graphql.bs.js");
var MyClientsWidgetSeller_status_seller_graphql = require("../../../__generated__/MyClientsWidgetSeller_status_seller_graphql.bs.js");

var convertFragment = MyClientsWidgetSeller_Menu_seller_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetSeller_Menu_seller_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_Menu_seller_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetSeller_Menu_seller_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetSeller_Menu_seller_graphql.node, convertFragment, fRef);
}

var SellerFragment_forSalePropertyMatchingType_decode = MyClientsWidgetSeller_Menu_seller_graphql.Utils.forSalePropertyMatchingType_decode;

var SellerFragment_forSalePropertyMatchingType_fromString = MyClientsWidgetSeller_Menu_seller_graphql.Utils.forSalePropertyMatchingType_fromString;

var SellerFragment = {
  forSalePropertyMatchingType_decode: SellerFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: SellerFragment_forSalePropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetSeller$Menu(props) {
  var seller = use(props.seller);
  var match = seller.property.status;
  var isArchived;
  switch (match.__typename) {
    case "ActiveProperty" :
    case "__unselected" :
        isArchived = false;
        break;
    default:
      isArchived = match.archived;
  }
  var hasActivityReport = Core__Array.keepSome(Core__Option.getOr(Core__Option.map(seller.property.broadcasts, (function (connection) {
                    return connection.edges;
                  })), [])).some(function (edge) {
        var match = edge.node.activityReport;
        if (match.__typename === "ActivityReportV5") {
          return true;
        } else {
          return false;
        }
      });
  var matchesCount = Core__Option.getOr(Core__Option.map(seller.property.matches, (function (m) {
              return m.totalCount;
            })), 0);
  var match$1 = React.useState(function () {
        return false;
      });
  var setDeleteDialogOpen = match$1[1];
  var match$2 = SystemMessages.useSystemMessages();
  var addMessage = match$2.addMessage;
  var handleRenewingError = function () {
    addMessage(SystemMessages.Message.make(undefined, "error", "There was an error making the property active. Please try again...", 5000, undefined, undefined));
  };
  var match$3 = RenewForSalePropertyMutation.use(seller.property.id, seller.property.nodeId, handleRenewingError, false);
  var makePropertyActiveIsLoading = match$3[1];
  var makePropertyActive = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var setMarkPropertyAsSoldDialogOpen = match$4[1];
  var match$5 = React.useState(function () {
        return false;
      });
  var setUnderContractDialogOpen = match$5[1];
  var match$6 = React.useState(function () {
        return false;
      });
  var setWithdrawPropertyDialogOpen = match$6[1];
  var match$7 = seller.property.forSaleMatchingType;
  var name;
  name = (match$7 === "QUIET" || match$7 === "ONE_WAY" || match$7 === "BROADCAST" || match$7 === "QUIET_ANONYMOUS") && match$7 === "BROADCAST" ? "Rebroadcast property" : "Broadcast property";
  var match$8 = seller.property.status;
  var name$1;
  switch (match$8.__typename) {
    case "ActiveProperty" :
        name$1 = match$8.isRenewable ? "Renew or change status" : "Change status";
        break;
    case "ExpiredProperty" :
        name$1 = "Renew or change status";
        break;
    default:
      name$1 = "Change status";
  }
  var tmp;
  if (isArchived) {
    tmp = JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
          name: name$1,
          unavailableReason: "The property has been archived",
          unavailableDescription: "Archived properties cannot be renewed or have their status changed."
        });
  } else {
    var match$9 = seller.property.status;
    var tmp$1;
    var exit = 0;
    switch (match$9.__typename) {
      case "ActiveProperty" :
          if (match$9.isRenewable) {
            exit = 1;
          } else {
            tmp$1 = null;
          }
          break;
      case "ExpiredProperty" :
          exit = 1;
          break;
      default:
        tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
              onAction: (function () {
                  makePropertyActive();
                }),
              isDisabled: makePropertyActiveIsLoading,
              children: "Change to active"
            });
    }
    if (exit === 1) {
      tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: (function () {
                makePropertyActive();
              }),
            isDisabled: makePropertyActiveIsLoading,
            children: "Renew property"
          });
    }
    var match$10 = seller.property.status;
    var tmp$2;
    tmp$2 = match$10.__typename === "SoldProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: (function () {
                setMarkPropertyAsSoldDialogOpen(function (param) {
                      return true;
                    });
              }),
            children: "Mark as sold"
          });
    var match$11 = seller.property.status;
    var tmp$3;
    tmp$3 = match$11.__typename === "UnderContractProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: (function () {
                setUnderContractDialogOpen(function (param) {
                      return true;
                    });
              }),
            children: "Mark as under contract"
          });
    var match$12 = seller.property.status;
    var tmp$4;
    tmp$4 = match$12.__typename === "WithdrawnProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: (function () {
                setWithdrawPropertyDialogOpen(function (param) {
                      return true;
                    });
              }),
            children: "Withdraw property"
          });
    tmp = JsxRuntime.jsxs(MenuV5.Submenu.make, {
          name: name$1,
          children: [
            tmp$1,
            tmp$2,
            tmp$3,
            tmp$4
          ],
          isDisabled: isArchived
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(MarkPropertyAsSoldDialog.make, {
                      propertyId: seller.property.id,
                      isOpen: match$4[0],
                      close: (function () {
                          setMarkPropertyAsSoldDialogOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsx(WithdrawForSalePropertyDialog.make, {
                      propertyId: seller.property.id,
                      isOpen: match$6[0],
                      close: (function () {
                          setWithdrawPropertyDialogOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsx(MarkPropertyAsUnderContractDialog.make, {
                      propertyId: seller.property.id,
                      isOpen: match$5[0],
                      close: (function () {
                          setUnderContractDialogOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsx(MyClientsWidgetDeleteDialog.make, {
                      client: seller.fragmentRefs,
                      isOpen: match$1[0],
                      onCancel: (function () {
                          setDeleteDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      onSuccess: (function () {
                          setDeleteDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      connectionId: props.connectionId
                    }),
                JsxRuntime.jsxs(MenuV5.Menu.make, {
                      button: JsxRuntime.jsx(ButtonsV5.Button.make, {
                            className: "!border-none",
                            children: Caml_option.some(JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "ThreeDots",
                                      size: 16,
                                      color: Theme__Color.black
                                    }))
                          }),
                      children: [
                        isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
                                name: "Edit property",
                                unavailableReason: "The property has been archived",
                                unavailableDescription: "Archived properties cannot be edited."
                              }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/properties/" + seller.property.id + "/edit",
                                children: "Edit property"
                              }),
                        isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
                                name: name,
                                unavailableReason: "The property has been archived",
                                unavailableDescription: "Archived properties cannot be broadcasted."
                              }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/properties/" + seller.property.id + "/broadcast",
                                children: name
                              }),
                        tmp,
                        matchesCount > 0 ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/my_clients/" + seller.id + "#matches",
                                children: "View matches (" + matchesCount.toString() + ")"
                              }) : null,
                        hasActivityReport ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/properties/" + seller.property.id + "/report",
                                children: "View activity report"
                              }) : null,
                        isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
                                name: "Delete seller",
                                unavailableReason: "The property has been archived",
                                unavailableDescription: "Archived properties cannot be deleted."
                              }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                onAction: (function () {
                                    setDeleteDialogOpen(function (param) {
                                          return true;
                                        });
                                  }),
                                children: "Delete seller"
                              })
                      ]
                    })
              ]
            });
}

var Menu = {
  SellerFragment: SellerFragment,
  make: MyClientsWidgetSeller$Menu
};

var convertFragment$1 = MyClientsWidgetSeller_name_seller_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetSeller_name_seller_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_name_seller_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetSeller_name_seller_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetSeller_name_seller_graphql.node, convertFragment$1, fRef);
}

var SellerFragment_forSalePropertyMatchingType_decode$1 = MyClientsWidgetSeller_name_seller_graphql.Utils.forSalePropertyMatchingType_decode;

var SellerFragment_forSalePropertyMatchingType_fromString$1 = MyClientsWidgetSeller_name_seller_graphql.Utils.forSalePropertyMatchingType_fromString;

var SellerFragment_visibilityReason_decode = MyClientsWidgetSeller_name_seller_graphql.Utils.visibilityReason_decode;

var SellerFragment_visibilityReason_fromString = MyClientsWidgetSeller_name_seller_graphql.Utils.visibilityReason_fromString;

var SellerFragment$1 = {
  forSalePropertyMatchingType_decode: SellerFragment_forSalePropertyMatchingType_decode$1,
  forSalePropertyMatchingType_fromString: SellerFragment_forSalePropertyMatchingType_fromString$1,
  visibilityReason_decode: SellerFragment_visibilityReason_decode,
  visibilityReason_fromString: SellerFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyClientsWidgetSeller$Name(props) {
  var seller = use$1(props.seller);
  var match = seller.property.forSalePropertyMatchingType;
  var tmp;
  if (match === "QUIET" || match === "ONE_WAY" || match === "BROADCAST" || match === "QUIET_ANONYMOUS") {
    switch (match) {
      case "BROADCAST" :
          tmp = "Broadcast property";
          break;
      case "ONE_WAY" :
          tmp = "Hidden property";
          break;
      case "QUIET" :
          tmp = "Quiet property";
          break;
      case "QUIET_ANONYMOUS" :
          tmp = "Quiet anonymous property";
          break;
      
    }
  } else {
    tmp = "Broadcast property";
  }
  var match$1 = seller.property.propertyLocation;
  var tmp$1;
  if (match$1 !== undefined && match$1.__typename === "PropertyLocationWithVisibleAddress") {
    var match$2 = match$1.visibilityRule;
    tmp$1 = match$2 !== undefined && (match$2 === "VISIBLE_TO_ALL" || match$2 === "VISIBLE_TO_ACCOUNT_MEMBER" || match$2 === "VISIBLE_TO_TAN_STAFF") && match$2 === "VISIBLE_TO_ACCOUNT_MEMBER" ? JsxRuntime.jsx(MyClientsWidgetComponents.HiddenAddressIcon.make, {}) : null;
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: tmp,
                              className: "text-gray-500 uppercase font-light"
                            }),
                        tmp$1
                      ],
                      className: "flex gap-2 items-center"
                    }),
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                      href: "my_clients/" + seller.id,
                      children: Caml_option.some(JsxRuntime.jsx("div", {
                                children: seller.displayName,
                                className: "text-lg"
                              }))
                    })
              ],
              className: "flex flex-col gap-1"
            });
}

var Name = {
  SellerFragment: SellerFragment$1,
  make: MyClientsWidgetSeller$Name
};

var convertFragment$2 = MyClientsWidgetSeller_status_seller_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetSeller_status_seller_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_status_seller_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetSeller_status_seller_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetSeller_status_seller_graphql.node, convertFragment$2, fRef);
}

var SellerFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyClientsWidgetSeller$Status$WithoutErrorBoundary(props) {
  var seller = use$2(props.seller);
  return JsxRuntime.jsx(OwnForSalePropertyStatusLabel.make, {
              forSaleProperty: seller.property.fragmentRefs
            });
}

var WithoutErrorBoundary = {
  ForSalePropertyStatusLabel: undefined,
  SellerFragment: SellerFragment$2,
  make: MyClientsWidgetSeller$Status$WithoutErrorBoundary
};

function MyClientsWidgetSeller$Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "seller status",
              children: JsxRuntime.jsx(MyClientsWidgetSeller$Status$WithoutErrorBoundary, {
                    seller: props.seller
                  })
            });
}

var Status = {
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: MyClientsWidgetSeller$Status
};

var convertFragment$3 = MyClientsWidgetSeller_seller_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetSeller_seller_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetSeller_seller_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetSeller_seller_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetSeller_seller_graphql.node, convertFragment$3, fRef);
}

var SellerFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function MyClientsWidgetSeller(props) {
  var seller = use$3(props.seller);
  return JsxRuntime.jsx(MyClientsWidgetRowLayout.make, {
              name: JsxRuntime.jsx(MyClientsWidgetSeller$Name, {
                    seller: seller.fragmentRefs
                  }),
              status: JsxRuntime.jsx(MyClientsWidgetSeller$Status, {
                    seller: seller.fragmentRefs
                  }),
              menu: JsxRuntime.jsx(MyClientsWidgetSeller$Menu, {
                    seller: seller.fragmentRefs,
                    connectionId: props.connectionId
                  })
            });
}

var Layout;

var Components;

var Link;

var DeleteDialog;

var make = MyClientsWidgetSeller;

exports.Layout = Layout;
exports.Components = Components;
exports.Link = Link;
exports.DeleteDialog = DeleteDialog;
exports.Menu = Menu;
exports.Name = Name;
exports.Status = Status;
exports.SellerFragment = SellerFragment$3;
exports.make = make;
/* react Not a pure module */
